
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateAudienceDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    description: new FormControl<string | undefined>('', [Validators.maxLength(500)]),
})
;
}
      